import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Grid, Typography, Alert, Paper } from '@mui/material';
import {
  CloudUpload as UploadIcon,
  Gavel as ValidateIcon,
  Person as ProfileIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';

function Dashboard({ wallet, contracts }) {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: 'Upload Content',
      description: 'Register new content with authenticity verification',
      icon: <UploadIcon fontSize="large" />,
      action: () => navigate('/upload'),
      color: '#4caf50',
    },
    {
      title: 'Validate Content',
      description: 'Review and validate content from other creators',
      icon: <ValidateIcon fontSize="large" />,
      action: () => navigate('/validate'),
      color: '#2196f3',
    },
    {
      title: 'View Profile',
      description: 'Check your reputation and content history',
      icon: <ProfileIcon fontSize="large" />,
      action: () => navigate('/profile'),
      color: '#9c27b0',
    },
  ];

  if (!wallet) {
    return (
      <Box sx={{ mt: 4 }}>
        <Alert severity="info" sx={{ mb: 4 }}>
          Please connect your wallet to access the full features of the platform.
        </Alert>
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <SecurityIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Welcome to SoulSig Trust System
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            A decentralized platform for verifying content authenticity and building trust in the
            digital age.
          </Typography>
          <Typography variant="body2" paragraph>
            • Register and verify content ownership
            <br />
            • Validate content authenticity
            <br />
            • Build reputation through honest participation
            <br />• Combat misinformation and deep fakes
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Dashboard
      </Typography>

      <Grid container spacing={3}>
        {quickActions.map((action, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  transition: 'transform 0.2s ease-in-out',
                },
              }}
              onClick={action.action}
            >
              <CardContent>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: '50%',
                      backgroundColor: `${action.color}20`,
                      color: action.color,
                      mb: 2,
                    }}
                  >
                    {action.icon}
                  </Box>
                  <Typography variant="h6" gutterBottom>
                    {action.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {action.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              System Statistics
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="primary">
                    {/* This would come from contract */}
                    247
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Registered Content
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="primary">
                    {/* This would come from contract */}
                    89
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Active Validators
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" color="primary">
                    {/* This would come from contract */}
                    1,432
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Total Validations
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Dashboard;
